import { render, staticRenderFns } from "./banner-home.vue?vue&type=template&id=fed951b2&"
import script from "./banner-home.vue?vue&type=script&lang=js&"
export * from "./banner-home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports